import { Pipe, PipeTransform } from '@angular/core';
import { ToolbarItemDirective } from '../directives/toolbar-item.directive';

/**
 * Filtering pipe used to filter toolbar items based on position
 */
@Pipe({
  name: 'toolbarButtonFilter',
  standalone: true,
})
export class ToolbarButtonFilterPipe implements PipeTransform {
  transform(
    items: ToolbarItemDirective[]
  ): ToolbarItemDirective[] {
    if (!items || !items.length) {
      return items;
    }

    return items.filter((p) => (p.type === 'button' || p.type === 'menu' ) && p.visible) ?? [];
  }
}